import links from 'common/helpers/links'
import cosmeticsProductTypes from 'common/helpers/constants/cosmeticsProductTypes'


interface ICosmeticsLinksWithTypes {
  [link: string]: string
}

const cosmeticsLinksWithTypes = [
  // makeup
  [ links.makeupEyeMascara, cosmeticsProductTypes.makeup.eye.eyeMascara ],
  [ links.makeupEyeEyebrow, cosmeticsProductTypes.makeup.eye.eyebrow ],
  [ links.makeupEyeTreatment, cosmeticsProductTypes.makeup.eye.eyeTreatment ],
  [ links.makeupEyeEyeliner, cosmeticsProductTypes.makeup.eye.eyeLiner ],
  [ links.makeupEyePrimer, cosmeticsProductTypes.makeup.eye.eyePrimer ],
  [ links.makeupEyeEyeshadow, cosmeticsProductTypes.makeup.eye.eyeshadow ],
  [ links.makeupLipLiner, cosmeticsProductTypes.makeup.lip.lipLiner ],
  [ links.makeupLipLipstick, cosmeticsProductTypes.makeup.lip.lipstick ],
  [ links.makeupLipLipgloss, cosmeticsProductTypes.makeup.lip.lipgloss ],
  [ links.makeupFacePrimer, cosmeticsProductTypes.makeup.face.facePrimer ],
  [ links.makeupConcealer, cosmeticsProductTypes.makeup.face.concealer ],
  [ links.makeupFaceFoundation, cosmeticsProductTypes.makeup.face.foundation ],
  [ links.makeupCheekBlush, cosmeticsProductTypes.makeup.cheek.cheekBlush ],
  [ links.makeupCheekHighlight, cosmeticsProductTypes.makeup.cheek.cheekHighlight ],
  [ links.makeupToolsBrushes, cosmeticsProductTypes.makeup.tools.brushes ],

  // personal care
  [ links.personalCareShowerBodyWash, cosmeticsProductTypes.personalCare.shower.bodyWash ],
  [ links.personalCareShowerBodyScrub, cosmeticsProductTypes.personalCare.shower.bodyScrubs ],
]
  .reduce((accum, [ key, value ]) => {
    if (typeof key === 'string') {
      accum[key] = value
    }

    return accum
  }, {}) as ICosmeticsLinksWithTypes


export default cosmeticsLinksWithTypes
